import * as React from "react";
import { SVGProps } from "react";
const SvgHomeSolutions = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <g clipPath="url(#home-solutions_svg__a)">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="m31.9 15.56-5.83-12a1 1 0 0 0-.9-.56H6.83a1 1 0 0 0-.9.56l-5.83 12A1 1 0 0 0 1 17h4v10a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1V17h4a1 1 0 0 0 .9-1.44ZM25 17v9H7V15H2.6L7.46 5h17.08l4.86 10H25v2Zm-3.688-3.918a1 1 0 0 0-1.628-1.163l-4.314 6.039-2.165-2.165a1 1 0 0 0-1.414 1.414l3 3a1 1 0 0 0 1.521-.125l5-7Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="home-solutions_svg__a">
        <path fill="#fff" d="M0 0h32v32H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgHomeSolutions;
